let setDate = (dt) => {
  let months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let currDate = new Date(dt);
  return `${currDate.getDate()}-${
    months[currDate.getMonth()]
  }-${currDate.getFullYear()}`;
};

export { setDate };
